import { Checkbox } from "@fluentui/react";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState, KeyboardEvent } from "react";
import AxiosConfig from "src/utilities/AxiosConfig";
import TextPopUp from "./ContractMaintenanceTextExtend";
import logger from "../../../utilities/logging"
import { qsStringify } from "src/utilities/helper";
import { Prompt, Redirect } from "react-router-dom";
import { Button, Modal, Overlay, Tooltip } from "react-bootstrap";
import snackBar from "src/utilities/snackBar/SnackBar";
import ContractDetails from "src/pages/settings/css_Settings/contract_maintenance/interfaces/ContractDetails";

interface BaseContactInfoType {
    ContractID: number,
    CustomerID: number,
    CustomerName: string,
    Contract_Description: string,
    VP_InCharge: string,
    State: string,
    PaymentTerms: number,
    Discount: string,
    StartDate: string,
    EndDate: string,
    IsAutoRenew: boolean,
    CPI: boolean,
    CPI_Character: string,
    CPIAmount: number,
    CPIEffectiveDate: string,
    FuelSurcharge: boolean,
    SurCharge_Character: string,
    FuelSurchargeAmount: number,
    FuelEffectiveDate: string,
    FuelEndDate: string,
    PriceIncrease: number,
    Comments: string,
    IsActive: boolean,
    IsDistributed: boolean,
    DistributionDate: string,
    IsTermableClause: string,
    TermNotes: string,
    IsLateFee: boolean,
    LateFeePercentage: number,
    LateFeeTerm: number,
    LimitLiability: boolean,
    LiabilityComments: string
}
interface customerDataType {
    CustomerName: string,
    CustomerID: number
}
interface newContractProps {
    customerData?: customerDataType[]
    renew: () => void
}

function ContractMaintenanceNewContract(props: newContractProps) {
    const [newRow, setNewRow] = useState<BaseContactInfoType>({} as BaseContactInfoType)
    const [customerData, setCustomerData] = useState(props.customerData)
    const [isEditing, setIsEditing] = useState(false)
    const [invalidInputs, setInvalidInputs] = useState<string[]>([])
    const PaymentTermsRef = useRef<HTMLInputElement>(null)
    const VPRef = useRef<HTMLInputElement>(null)
    const StateRef = useRef<HTMLInputElement>(null)
    const invalidWarningStyle = { backgroundColor: "ivory", border: "none", outline: "2px solid red", borderRadius: "5px" }
    const nullPlacment = ""
    const required = ["CustomerName", "CustomerID", "VP_InCharge", "State", "PaymentTerms", "StartDate", "EndDate", "IsTermableClause"]
    const [error, setError] = useState(false)
    const [addRowCon, setAddRowCon] = useState(false)
    const [cancelAddRow, setCancelAddRow] = useState(false)
    const [showWarning, setShowWarning] = useState(false)
    const [businessHours, setBusinessHours] = useState<(string | null)[]>(["", ""]);
    const setEditData = (key: keyof BaseContactInfoType, edit: string) => {
        let alter = newRow
        if (key === "CustomerName") {
            alter[key] = edit
            alter.CustomerID = customerData?.find((x) => x.CustomerName === edit)?.CustomerID ?? -99
        }
        else if (
            key === "PaymentTerms" ||
            key === "CPIAmount" ||
            key === "FuelSurchargeAmount" ||
            key === "PriceIncrease" ||
            key === "LateFeePercentage" ||
            key === "LateFeeTerm" ||
            key === "CustomerID" ||
            key === "ContractID") {
            alter[key] = Number(edit)
        }
        else if (key === "IsAutoRenew" || key === "CPI" || key === "FuelSurcharge" || key === "IsActive" || key === "IsDistributed" || key === "IsLateFee" || key === "LimitLiability") {
            if (key === "CPI" && !alter[key]) {
                alter = { ...alter, CPI_Character: "", CPIAmount: 0, CPIEffectiveDate: "" }
            }
            if (key === "FuelSurcharge" && !alter[key]) {
                alter = { ...alter, SurCharge_Character: "", FuelSurchargeAmount: 0, FuelEffectiveDate: "", FuelEndDate: "" }
            }
            if (key === "IsDistributed" && !alter[key]) {
                alter = { ...alter, DistributionDate: "" }
            }
            alter[key] = !alter[key]
        }
        else if (key === "StartDate") {
            alter[key] = edit
        }
        else {
            alter[key] = edit
        }
        setNewRow({ ...alter })
    }
    const insertData = () => {
        let keys = Object.keys(newRow as BaseContactInfoType)
        keys = keys.filter((x) => newRow[x as keyof BaseContactInfoType].toString().trim() !== "")
        let forgotten = required.filter((x) => keys.find((y) => y === x) === undefined)
        //console.log(newRow.StartDate, newRow.EndDate)
        if (!newRow.StartDate || isNaN(moment(newRow.EndDate).valueOf()) || moment(newRow.StartDate).valueOf() > moment(newRow.EndDate).valueOf()) {
            alert("Invalid Start Date/End Date pair")
            return null
        }
        if (!Array.isArray(forgotten) || !forgotten.length) {
            axios.post(process.env.REACT_APP_API_URL + `/api/billing/InsertBaseContractInfo`, qsStringify({
                ...newRow
            }), AxiosConfig.configValue())
                .then((res) => {
                    if (res.data.error) {
                        setNewRow({
                            CustomerName: props.customerData ? props.customerData[0].CustomerName : "",
                            CustomerID: props.customerData ? props.customerData[0].CustomerID : null,
                            IsActive: true,
                            IsAutoRenew: false,
                            IsDistributed: false,
                            IsLateFee: false,
                            IsTermableClause: "0",
                            LimitLiability: false,
                            CPI: false,
                            FuelSurcharge: false,
                            StartDate: new Date().toUTCString(),
                            EndDate: new Date().toUTCString(),
                        } as BaseContactInfoType)
                        setInvalidInputs([])
                        setCancelAddRow(false)
                        setIsEditing(false)
                        throw Error(res.data.error.message)
                    }
                    setNewRow({
                        IsActive: false,
                        IsAutoRenew: false,
                        IsDistributed: false,
                        IsLateFee: false,
                        IsTermableClause: "0",
                        LimitLiability: false,
                        CPI: false,
                        FuelSurcharge: false,
                        StartDate: new Date().toUTCString(),
                        EndDate: new Date().toUTCString(),
                        CustomerName: props.customerData ? props.customerData[0].CustomerName : "",
                        CustomerID: props.customerData ? props.customerData[0].CustomerID : -99
                    } as BaseContactInfoType)
                    setIsEditing(false)
                })
                .then(() => {
                    if (props.customerData && props.customerData[0].CustomerID) {
                        const rb = {
                            CustomerID: props.customerData[0].CustomerID,
                            //@ts-ignore
                            BusinessHoursStart: businessHours[0]?.length > 0 ? businessHours[0] : null,
                            //@ts-ignore
                            BusinessHoursEnd: businessHours[1]?.length > 0 ? businessHours[1] : null,
                        }
                        axios.post(`${process.env.REACT_APP_API_URL}/api/billing/addContractDetails`, rb, AxiosConfig.configValue("min"))
                    } else {
                        snackBar({ type: "info", text: "There is no CustomerID for this contract, business hours cannot be saved", timeout: 5000 })
                    }
                })
                .finally(() => props.renew())
                .catch(error => {
                    alert(`There was an error Inserting Contract Info(${error}). Reloading page...`);
                    //console.log(error);
                    logger.Error({
                        EventMessage: `ContractMaintenance -> UpdateContractInfo -> Error : ${JSON.stringify(error)}`,
                        EventCategory: "httprequest"
                    });
                    AxiosConfig.handleError(error);
                    setError(true)
                    return null
                })
        }
        else {
            alert(`Invalid inputs in columns ${forgotten}`)
            setShowWarning(true)
            if (forgotten.find((x) => x === "VP_InCharge")) {
                VPRef.current?.focus()
            }
            else if (forgotten.find((x) => x === "State")) {
                StateRef.current?.focus();
            }
            else if (forgotten.find((x) => x === "PaymentTerms")) {
                PaymentTermsRef.current?.focus();
            }
        }
        setInvalidInputs(forgotten)
    }

    const editBusinessHours = (event: { target: { value: string } }, index: number) => {
        const input = event.target.value;
        const updatedBusinessHours = businessHours ? [...businessHours] : ["", ""];
        updatedBusinessHours[index] = input || null;
        setBusinessHours(updatedBusinessHours);
    };




    useEffect(() => {
        let copyData = newRow
        if (props.customerData) {
            copyData.CustomerName = props.customerData[0].CustomerName
            copyData.CustomerID = props.customerData[0].CustomerID
        }
        setCustomerData(props.customerData?.sort((a, b) => a.CustomerName > b.CustomerName ? 1 : -1))
        setNewRow(
            {
                ...copyData,
                IsActive: true,
                IsAutoRenew: false,
                IsDistributed: false,
                IsLateFee: false,
                IsTermableClause: "0",
                LimitLiability: false,
                CPI: false,
                FuelSurcharge: false,
                StartDate: new Date().toUTCString(),
                EndDate: new Date().toUTCString(),
            }
        )
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [props.customerData])
    useEffect(() => {
        const timerId = setInterval(() => {
            setShowWarning(false)
        }, 3000);

        return () => clearInterval(timerId);
        //r-18-lint-cn
        //eslint-disable-next-line
    });
    return (
        <>
            {
                isEditing ?
                    <tr className="newContractRow">
                        <td className="sticky-table-column-left newRow" style={{ zIndex: 10 }}>{newRow.ContractID ?? nullPlacment}</td>
                        <td className="newRow">{newRow.CustomerID}</td>
                        <td>
                            <div className="editableSelect">
                                <select value={newRow.CustomerName ?? nullPlacment} onChange={(e) => setEditData("CustomerName", e.target.value)}>
                                    {customerData?.map((x) => (
                                        <option key={x.CustomerID}>{x.CustomerName}</option>
                                    ))}
                                </select>
                            </div>
                        </td>
                        <td >
                            <div className="editPop">
                                <TextPopUp text={newRow.Contract_Description ?? nullPlacment} onChange={(e: string) => { setEditData("Contract_Description", e) }} warning={false} disabled={false} maxLength={150} />
                            </div>
                        </td>
                        <td >
                            <div className="editMedium">
                                <input
                                    type="text"
                                    value={newRow.VP_InCharge ?? nullPlacment}
                                    //r-18-lint-cn
                                    //eslint-disable-next-line
                                    onChange={(e) => (setEditData("VP_InCharge", e.target.value), setInvalidInputs(invalidInputs.filter((x) => x !== "VP_InCharge")))}
                                    style={invalidInputs.find((x) => x === "VP_InCharge") ? invalidWarningStyle : undefined}
                                    ref={VPRef}
                                    maxLength={50}
                                />
                                <Overlay
                                    target={VPRef.current}
                                    show={invalidInputs.find((x) => x === "VP_InCharge") ? showWarning : false}
                                    placement="bottom"
                                    rootClose={true}
                                    rootCloseEvent="click"
                                    onHide={() => setShowWarning(false)}
                                >
                                    {(props) => (
                                        <Tooltip className="cmWarningInput" id="overlay-example" {...props}>
                                            Invalid Input
                                        </Tooltip>
                                    )}
                                </Overlay>
                            </div>
                        </td>
                        <td ><div className="editSmall">
                            <input
                                type="text"
                                value={newRow.State ?? nullPlacment}
                                //r-18-lint-cn
                                //eslint-disable-next-line
                                onChange={(e) => (setEditData("State", e.target.value), setInvalidInputs(invalidInputs.filter((x) => x !== "State")))}
                                style={invalidInputs.find((x) => x === "State") ? invalidWarningStyle : undefined}
                                ref={StateRef}
                                maxLength={3}
                            />
                            <Overlay
                                target={StateRef.current}
                                show={invalidInputs.find((x) => x === "State") ? showWarning : false}
                                placement="bottom" rootClose={true}
                                rootCloseEvent="click"
                                onHide={() => setShowWarning(false)}
                            >
                                {(props) => (
                                    <Tooltip className="cmWarningInput" id="overlay-example" {...props}>
                                        Invalid Input
                                    </Tooltip>
                                )}
                            </Overlay>
                        </div>
                        </td>
                        <td >
                            <div className="editSmall">
                                <input
                                    type="number"
                                    defaultValue={newRow.PaymentTerms ?? nullPlacment}
                                    //r-18-lint-cn
                                    //eslint-disable-next-line
                                    onChange={(e) => (setEditData("PaymentTerms", e.target.value), setInvalidInputs(invalidInputs.filter((x) => x !== "PaymentTerms")))}
                                    style={invalidInputs.find((x) => x === "PaymentTerms") ? invalidWarningStyle : undefined}
                                    ref={PaymentTermsRef}
                                    onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                />
                                <Overlay
                                    target={PaymentTermsRef.current}
                                    show={invalidInputs.find((x) => x === "PaymentTerms") ? showWarning : false}
                                    placement="bottom" rootClose={true}
                                    rootCloseEvent="click"
                                    onHide={() => setShowWarning(false)}
                                >
                                    {(props) => (
                                        <Tooltip className="cmWarningInput" id="overlay-example" {...props} >
                                            Invalid Input
                                        </Tooltip>
                                    )}
                                </Overlay>
                            </div>

                        </td>
                        <td>
                            <div className="editPop">
                                <TextPopUp text={newRow.Discount} onChange={(e: string) => { setEditData("Discount", e) }} warning={false} disabled={false} maxLength={20} />
                            </div>
                        </td>
                        <td>
                            <div className="editDate">
                                <input type='date' onChange={(e) => { setEditData("StartDate", moment(e.target.value).format()) }} defaultValue={moment(newRow.StartDate).format("YYYY-MM-DD")} />
                            </div>
                        </td>
                        <td>
                            <div className="editDate">
                                <input type='date' onChange={(e) => { setEditData("EndDate", moment(e.target.value).format()) }} defaultValue={moment(newRow.EndDate).format("YYYY-MM-DD")} />
                            </div>
                        </td>
                        <td>
                            <div className="editCheck">
                                <Checkbox checked={newRow.IsAutoRenew ?? nullPlacment} onChange={(e) => setEditData("IsAutoRenew", (!newRow.IsAutoRenew).toString())} />
                            </div>
                        </td>
                        <td>
                            <div className="editCheck">
                                <Checkbox checked={newRow.CPI ?? nullPlacment} onChange={(e) => setEditData("CPI", (!newRow.CPI).toString())} />
                            </div>
                        </td>
                        <td>
                            <div className="editSmall">
                                <input type="text" value={newRow.CPI_Character ?? nullPlacment} onChange={(e) => { setEditData("CPI_Character", e.target.value) }} disabled={!newRow.CPI} maxLength={1}></input>
                            </div>
                        </td>
                        <td>
                            <div className="editSmall">
                                <input type="number" defaultValue={newRow.CPIAmount ?? nullPlacment} onChange={(e) => setEditData("CPIAmount", e.target.value)} disabled={!newRow.CPI}></input>
                            </div>
                        </td>
                        <td>
                            <div className="editDate">
                                {
                                    newRow.CPI ?
                                        <input type='date' onChange={(e) => { setEditData("CPIEffectiveDate", moment(e.target.value).format()) }} defaultValue={moment(newRow.CPIEffectiveDate).format("YYYY-MM-DD")} /> :
                                        null
                                }
                            </div>
                        </td>
                        <td>
                            <div className="editCheck">
                                <Checkbox checked={newRow.FuelSurcharge ?? nullPlacment} onChange={(e) => setEditData("FuelSurcharge", (!newRow.FuelSurcharge).toString())} />
                            </div>
                        </td>
                        <td>
                            <div className="editSmall">
                                <input
                                    type="text"
                                    value={newRow.SurCharge_Character ?? nullPlacment}
                                    onChange={(e) => setEditData("SurCharge_Character", e.target.value)}
                                    disabled={!newRow.FuelSurcharge}
                                    maxLength={1}
                                />
                            </div>
                        </td>
                        <td>
                            <div className="editSmall">
                                <input
                                    type="number"
                                    defaultValue={newRow.FuelSurchargeAmount ?? nullPlacment}
                                    onChange={(e) => setEditData("FuelSurchargeAmount", e.target.value)}
                                    disabled={!newRow.FuelSurcharge}
                                    onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                />
                            </div>
                        </td>
                        <td>
                            <div className="editDate">
                                {
                                    newRow.FuelSurcharge ?
                                        <input type='date' onChange={(e) => { setEditData("FuelEffectiveDate", moment(e.target.value).format()) }} defaultValue={moment(newRow.FuelEffectiveDate).format("YYYY-MM-DD")} /> :
                                        null
                                }
                            </div>
                        </td>
                        <td>
                            <div className="editDate">
                                {
                                    newRow.FuelSurcharge ?
                                        <input type='date' onChange={(e) => { setEditData("FuelEndDate", moment(e.target.value).format()) }} defaultValue={moment(newRow.FuelEndDate).format("YYYY-MM-DD")} /> :
                                        null
                                }
                            </div>
                        </td>
                        <td>
                            <div className="editSmall">
                                <input
                                    type="number"
                                    defaultValue={newRow.PriceIncrease ?? nullPlacment}
                                    onChange={(e) => setEditData("PriceIncrease", e.target.value)}
                                    onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                />
                            </div>
                        </td>
                        <td>
                            <div className="editPop">
                                <TextPopUp text={newRow.Comments} onChange={(e: string) => { setEditData("Comments", e) }} warning={false} disabled={false} maxLength={3500} />
                            </div>
                        </td>
                        <td>
                            <div className="editCheck">
                                <Checkbox checked={newRow.IsActive ?? nullPlacment} onChange={(e) => setEditData("IsActive", (!newRow.IsActive).toString())} />
                            </div>
                        </td>
                        <td>
                            <div className="editCheck">
                                <Checkbox checked={newRow.IsDistributed ?? nullPlacment} onChange={(e) => setEditData("IsDistributed", (!newRow.IsDistributed).toString())} />
                            </div>
                        </td>
                        <td>
                            <div className="editDate">
                                {
                                    newRow.IsDistributed ?
                                        <input type='date' onChange={(e) => { setEditData("DistributionDate", moment(e.target.value).format()) }} defaultValue={moment(newRow.DistributionDate).format("YYYY-MM-DD")} /> :
                                        null
                                }
                            </div>
                        </td>
                        <td>
                            <div className="editSmall">
                                <input type="text" value={newRow.IsTermableClause ?? nullPlacment} onChange={(e) => setEditData("IsTermableClause", e.target.value)} maxLength={10}></input>
                            </div>
                        </td>
                        <td>
                            <div className="editPop">
                                <TextPopUp text={newRow.TermNotes} onChange={(e: string) => { setEditData("TermNotes", e) }} warning={false} disabled={newRow.IsTermableClause !== "-1"} maxLength={5000} />
                            </div>
                        </td>
                        <td>
                            <div className="editCheck">
                                <Checkbox checked={newRow.IsLateFee ?? nullPlacment} onChange={(e) => setEditData("IsLateFee", (!newRow.IsLateFee).toString())} />
                            </div>
                        </td>
                        <td>
                            <div className="editSmall">
                                <input
                                    type="number"
                                    defaultValue={newRow.LateFeePercentage ?? nullPlacment}
                                    onChange={(e) => setEditData("LateFeePercentage", e.target.value)}
                                    disabled={!newRow.IsLateFee}
                                    onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                />
                            </div>
                        </td>
                        <td>
                            <div className="editSmall">
                                <input
                                    type="number"
                                    defaultValue={newRow.LateFeeTerm ?? nullPlacment}
                                    onChange={(e) => setEditData("LateFeeTerm", e.target.value)}
                                    disabled={!newRow.IsLateFee}
                                    onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                />
                            </div>
                        </td>
                        <td>
                            <div className="editCheck">
                                <Checkbox checked={newRow.LimitLiability ?? nullPlacment} onChange={(e) => setEditData("LimitLiability", (!newRow.LimitLiability).toString())} />
                            </div>
                        </td>
                        <td>
                            <div className="editPop">
                                <TextPopUp text={newRow.LiabilityComments ?? nullPlacment} onChange={(e: string) => { setEditData("LiabilityComments", e) }} warning={false} disabled={false} maxLength={5000} />
                            </div>
                        </td>

                        <td>
                            <input
                                type="time"
                                value={businessHours && businessHours[0] ? businessHours[0] : ""}
                                onChange={(e) => editBusinessHours(e, 0)}
                                maxLength={5}
                            />
                        </td>

                        <td>
                            <input
                                type="time"
                                value={businessHours && businessHours[1] ? businessHours[1] : ""}
                                onChange={(e) => editBusinessHours(e, 1)}
                                maxLength={5}
                            />
                        </td>


                        <td className="sticky-table-column-right"><span className="material-icons" onClick={() => (setCancelAddRow(true))}>cancel</span><span className="material-icons" onClick={() => setAddRowCon(true)}>save</span></td>
                    </tr> :
                    <tr className="newContractRow" onClick={() => setIsEditing(true)}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="sticky-table-column-right"><span className="material-icons addRow">add</span></td>
                    </tr>
            }
            {
                error ?
                    <Redirect to="/css/contract-maintenance" /> : null
            }
            <Modal show={addRowCon} size="lg" onHide={() => setAddRowCon(false)}>
                <Modal.Header>
                    <span>Are you sure you want to add a new record </span>
                </Modal.Header>
                <Modal.Footer>
                    {/*r-18-lint-cn*/}
                    {/*eslint-disable-next-line*/}
                    <Button onClick={() => (insertData(), setAddRowCon(false))} variant='primary'>Yes</Button>
                    <Button onClick={() => setAddRowCon(false)} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={cancelAddRow} size="lg" onHide={() => setCancelAddRow(false)}>
                <Modal.Header>
                    <span>Are you sure you want to cancel adding a new Record</span>
                </Modal.Header>
                <Modal.Footer>
                    <Button
                        onClick={() => {
                            setIsEditing(false)
                            setNewRow({
                                CustomerName: props.customerData ? props.customerData[0].CustomerName : "",
                                CustomerID: props.customerData ? props.customerData[0].CustomerID : null,
                                IsActive: true,
                                IsAutoRenew: false,
                                IsDistributed: false,
                                IsLateFee: false,
                                IsTermableClause: "0",
                                LimitLiability: false,
                                CPI: false,
                                FuelSurcharge: false,
                                StartDate: new Date().toUTCString(),
                                EndDate: new Date().toUTCString(),
                            } as BaseContactInfoType)
                            setInvalidInputs([])
                            setCancelAddRow(false)
                        }}
                        variant='primary'
                    >
                        Yes
                    </Button>
                    <Button onClick={() => setCancelAddRow(false)} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>
            {
                error ?
                    <Redirect to="/css/contract-maintenance" /> : null
            }
            <Prompt
                when={isEditing}
                message='You have unsaved changes, are you sure you want to leave?'
            />
        </>
    )
}

export default ContractMaintenanceNewContract
